import React, { memo, useCallback, useState } from 'react';
import { useObservable } from 'react-use-observable';

import { Badge, Spin } from 'antd';
import { Icon } from '@eduzz/ui-antd-theme';

import chatService from 'v2/services/chat';

import Topbar from '@eduzz/ui-layout/Topbar';

import MessagesList from './MessagesList';

const ChatMessages = memo(() => {
  const [isOpen, setIsOpen] = useState(false);
  const [isFirstOpen, setIsFirstOpen] = useState(true);

  const [unreadMessagesCount, unreadMessagesCountError] = useObservable(() => chatService.getChatUnreadCount(), []);

  const isLoadingCount = unreadMessagesCount === null && unreadMessagesCountError === undefined;

  const handleOpenChange = useCallback((open: boolean) => {
    setIsOpen(open);

    if (!open) {
      setIsFirstOpen(false);
    }
  }, []);

  if (isLoadingCount) {
    return <Spin size='small' />;
  }

  return (
    <MessagesList
      isFirstOpen={isFirstOpen}
      unreadMessagesCount={unreadMessagesCount}
      isOpen={isOpen}
      onOpenChange={handleOpenChange}
    >
      <span>
        <Topbar.Action
          id='topbar-action-messages'
          aria-label='mostrar mensagens'
          icon={<Icon.MessageCircle  />}
          tooltip='Mensagens'
          badgeCount={unreadMessagesCount}
        />
      </span>
    </MessagesList>
  );
});

export default ChatMessages;
